export default {
    data() {
      return {
        inactivityTimeout: null,
         inactivityTimeLimit: 2 * 365 * 24 * 60 * 60 * 1000
      };
    },
    created() {
      // Intentionally disabled to avoid automatic logout.
      // Session persistence should now depend on explicit logout
      // or backend token expiry instead of browser inactivity.
    },
    methods: {
      resetInactivityTimeout() {
        clearTimeout(this.inactivityTimeout);
        this.inactivityTimeout = setTimeout(this.logoutUser, this.inactivityTimeLimit);
      },
      setupActivityListeners() {
        window.addEventListener('mousemove', this.resetInactivityTimeout);
        window.addEventListener('keydown', this.resetInactivityTimeout);
        window.addEventListener('click', this.resetInactivityTimeout);
        window.addEventListener('scroll', this.resetInactivityTimeout);
      },
      logoutUser() {
        // Perform logout actions here
        window.location.href = '/';
      }
    },
    beforeDestroy() {
      clearTimeout(this.inactivityTimeout);
    }
  };
  
